module.exports = __webpack_public_path__ + "04c66807c96ed02adb446b5d597b506d.pdf";